module.exports = __webpack_public_path__ + "static/media/process.4f30d1b6.svg";